import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface PoiNotesInputProps {
  onPoiNotesChange: (value: string) => void;
  poiNotesValue: string;
  isEnabled: boolean;
}

export const PoiNotesInput: React.FC<PoiNotesInputProps> = ({
  onPoiNotesChange,
  poiNotesValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="POI Notes"
      label="Enter POI Notes:"
      placeholder="Enter POI notes..."
      value={poiNotesValue}
      onChange={onPoiNotesChange}
      isEnabled={isEnabled}
      isTextArea={true}
    />
  );
};
